module.exports = __webpack_public_path__ + "img/@work_KBstar_list.e97ce596.jpg";